import { BRAND } from "@/lib/brand";
import { useBrand } from "@/lib/branding";

/** "Powered by DATADOVE" credit linking to the vendor site (unless a partner hides it). */
export function PoweredBy({ onDark = false, className = "" }: { onDark?: boolean; className?: string }) {
  // A partner may hide the credit on their own domain.
  if (!useBrand().powered_by) return null;
  return (
    <a href={BRAND.vendor.url} target="_blank" rel="noopener noreferrer"
      className={`inline-flex items-center gap-1.5 text-xs ${onDark ? "text-white/80 hover:text-white" : "text-muted hover:text-brand"} ${className}`}
      aria-label={`Powered by ${BRAND.vendor.name} (opens datadove.tech in a new tab)`}>
      Powered by
      <img src={onDark ? "/brand/icon-white.png" : BRAND.icon} alt="" className="h-4 w-4" />
      <span className={`font-bold tracking-[0.12em] ${onDark ? "text-white" : "text-brand-logo"}`}>{BRAND.vendor.name}</span>
    </a>
  );
}
